(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cozy-personalisation"] && !Shopify.designMode) return;
  try {
    class CozyManualPersonalisation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('input', () => this.validate(), { signal: this.controller.signal });
      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== this.dataset.formId) return;
        for (const field of this.querySelectorAll('[data-cozy-field]')) field.value = field.value.trim();
        this.validate();
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.reportValidity();
        }
      }, { capture: true, signal: this.controller.signal });
      this.validate();
    }
    disconnectedCallback() { this.controller?.abort(); }
    validate() {
      for (const field of this.querySelectorAll('[data-cozy-field]')) {
        const value = field.value.trim();
        field.setCustomValidity('');
        if (field.required && value.length === 0) {
          field.setCustomValidity(this.dataset.errorRequired);
          continue;
        }
        if (!value) continue;
        if (field.dataset.cozyRule === 'date') {
          const match = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.([12][0-9]{3})$/.exec(value);
          let valid = false;
          if (match) {
            const day = Number(match[1]), month = Number(match[2]), year = Number(match[3]);
            const date = new Date(Date.UTC(year, month - 1, day));
            valid = date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
          }
          if (!valid) field.setCustomValidity(this.dataset.errorDate);
        }
        if (field.dataset.cozyRule === 'initial' && !/^\p{L}$/u.test(value)) field.setCustomValidity(this.dataset.errorInitial);
        if (field.dataset.cozyRule === 'initials' && !/^\p{L}{1,2}$/u.test(value)) field.setCustomValidity(this.dataset.errorInitial);
      }
      const from = this.querySelector('[data-cozy-field="from_year"]');
      const to = this.querySelector('[data-cozy-field="to_year"]');
      if (from?.value.trim() && to?.value.trim() && Number(to.value) < Number(from.value)) to.setCustomValidity(this.dataset.errorYearRange);
    }
  }
  if (!customElements.get('cozy-manual-personalisation')) customElements.define('cozy-manual-personalisation', CozyManualPersonalisation);
  } catch(e) { console.error(e); }
})();

})();
